import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=aa2405a2"
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports